import "jquery.repeater";

$(function () {
    $("#cms-recommended-statements-language").change(function () {
        const recommendedStatementsEditUrl = $(this).data('recommended-statements-edit-url');
        const selectedLanguageId = $(this).val();

        window.location = recommendedStatementsEditUrl+'/'+selectedLanguageId;
    });

    $(".admin-cms-statements-repeater").repeater({
        initEmpty: false,
        defaultValues: {},
        show: function () {
            $(this).slideDown()
        },
        hide: function (deleteElement) {
            $(this).slideUp(deleteElement);
        },
    })
})

